import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface Props {
  roles: string[];
  children: React.ReactNode;
}

function Spinner() {
  return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F8FAFF' }}>
      <div style={{ width: 32, height: 32, border: '3px solid #E2E8F0', borderTopColor: '#4F46E5', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function ProtectedRoute({ roles, children }: Props) {
  const { user, groups, userAttributes, isLoading } = useAuth();

  if (isLoading) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;

  // If user hasn't accepted EULA, gate them regardless of role
  if (!userAttributes['custom:agreed_eula']) {
    return <Navigate to="/eula" replace />;
  }

  // If user isn't in any required role group yet (just signed up, not yet assigned)
  if (roles.length > 0 && !roles.some(r => groups.includes(r))) {
    return <Navigate to="/pending" replace />;
  }

  return <>{children}</>;
}
